import Icon from 'veui/components/Icon'
import { IconSettings } from 'dls-icons-vue'

Icon.register('settings', IconSettings)
